import { useMemo } from 'react';
import useAgenciesDataStore from '../useAgenciesDataStore';
import useOohRoutesDataStore from '../useOohRoutesDataStore';
import useOohCourierTripsDataStore from '../useOohCourierTripsDataStore';
import useCourierPositionsDataStore from '../useCourierPositionsDataStore';
import { TrafficUpdatesGrpcServiceClient } from '../../grpc/TrafficUpdatesServiceClientPb';

const trafficUpdatesServiceUrl = `${process.env.REACT_APP_HISTORICAL_DATA_GRPC_URL}`;
const client = new TrafficUpdatesGrpcServiceClient(trafficUpdatesServiceUrl);

export const useOohData = (
  dateParamValue: string | null,
  agencyParamValue: string | null,
  routeParamValue: string | null,
  selectedCourier: number | null,
) => {
  const { agenciesData } = useAgenciesDataStore();
  const { oohRoutes } = useOohRoutesDataStore(dateParamValue, agencyParamValue);
  const { areCourierTripsLoading, courierTrips } = useOohCourierTripsDataStore(
    dateParamValue,
    routeParamValue,
  );
  const { courierPositions } = useCourierPositionsDataStore(
    dateParamValue,
    selectedCourier,
    client,
  );

  const selectedAgency = useMemo(() => 
    agenciesData.find((agency) => agency.id === agencyParamValue),
    [agenciesData, agencyParamValue]
  );

  const selectedRoute = useMemo(() => 
    oohRoutes.find((route) => route.id === routeParamValue),
    [oohRoutes, routeParamValue]
  );

  const liveTrackingCoordinates = useMemo(() => 
    selectedCourier !== null ? courierPositions : [],
    [selectedCourier, courierPositions]
  );

  return {
    agenciesData,
    oohRoutes,
    courierTrips,
    courierPositions,
    selectedAgency,
    selectedRoute,
    liveTrackingCoordinates,
    areCourierTripsLoading,
  };
};